<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <g fill="none" fill-rule="evenodd" stroke="#000" stroke-width="1.5">
        <path d="M5.9 10.1L1 15M15 1l-4.9 4.9M10.1 10.1L15 15M1 1l4.9 4.9"/>
        <path stroke-linecap="square" d="M10.8 1H15v4.2M5.2 15H1v-4.2M1 5.2V1h4.2M15 10.8V15h-4.2"/>
    </g>
</svg>
